import { useMutation, useQueryClient } from '@tanstack/react-query'
import request from '@/services/request'
import { IUserMe } from '@/types/user'

export const useUpdateNotificationSettings = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (notification_enabled: boolean) =>
      request.private
        .patch('users/v2/me/notification/', {
          notifications_enabled: notification_enabled,
        })
        .then((r) => r.data),
    onSuccess: (_, notification_enabled) => {
      queryClient.setQueryData<IUserMe>(['user-me'], (old) => {
        if (!old) return old
        return { ...old, notifications_enabled: notification_enabled }
      })
    },
  })
}
